import { Loading } from 'element-ui';
let loading;
let timer=null
export let LoadingCom= {start: ()=>{
     loading=  Loading.service({
        lock: true, // 是否锁屏
      text: '', // 加载动画的文字
      spinner: '', // 引入的loading图标
      background: 'rgba(255, 255, 255)' // 背景颜色
      })
      if(timer!=null){
        clearTimeout(timer)
    
      }
         timer= setTimeout(function() { // 设定定时器，超时10S后自动关闭遮罩层，避免请求失败时，遮罩层一直存在的问题
                    loading.close() // 关闭遮罩层
        }, 10000)

} ,
close: ()=>{loading.close()} } 